import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Collection from './pages/Collection';
import Product from './pages/Product';
import Appointments from './pages/Appointments';
import About from './pages/About';
import DiamondEducation from './pages/DiamondEducation';
import GoldVermeil from './pages/GoldVermeil';
import Gifting from './pages/Gifting';
import Customise from './pages/Customise';
import Blogs from './pages/Blogs';
import BlogPost from './pages/BlogPost';
import Reviews from './pages/Reviews';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import CartDrawer from './components/CartDrawer';
import WhatsAppButton from './components/WhatsAppButton';
import { CartProvider } from './context/CartContext';
import { Toaster } from './components/ui/sonner';

function App() {
  return (
    <div className="App">
      <CartProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Header />
          <CartDrawer />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/collections/:slug" element={<Collection />} />
            <Route path="/collections/:slug/:subSlug" element={<Collection />} />
            <Route path="/products/:id" element={<Product />} />
            <Route path="/appointments" element={<Appointments />} />
            <Route path="/about" element={<About />} />
            <Route path="/reviews" element={<Reviews />} />
            <Route path="/services/gifting" element={<Gifting />} />
            <Route path="/services/customise" element={<Customise />} />
            <Route path="/faqs" element={<DiamondEducation />} />
            <Route path="/blogs" element={<Blogs />} />
            <Route path="/blogs/:slug" element={<BlogPost />} />
            <Route path="/pages/diamond-education" element={<DiamondEducation />} />
            <Route path="/pages/gold-vermeil" element={<GoldVermeil />} />
            <Route path="/pages/:slug" element={<Home />} />
          </Routes>
          <Footer />
          <WhatsAppButton />
          <Toaster position="top-right" duration={2000} />
        </BrowserRouter>
      </CartProvider>
    </div>
  );
}

export default App;
